import { Box } from '@mui/material'
import { useStreamTextReveal } from '@/features/chat/streaming/useStreamTextReveal'
import { splitStreamTail } from '@/features/chat/streaming/splitStreamTail'
import StreamingCaret from './StreamingCaret'
import { renderStreamBody } from './streamTailBody'
import styles from './StreamingText.module.scss'

export function StreamingTextPlaceholder({ className, sx }) {
  return (
    <Box
      component="span"
      className={[styles.placeholder, className].filter(Boolean).join(' ')}
      sx={sx}
      aria-busy="true"
      aria-label="Loading content"
    >
      <StreamingCaret />
    </Box>
  )
}

export default function StreamingText({
  text,
  showCaret = true,
  formatted = false,
  streaming = false,
  className,
  sx,
  component = 'div',
}) {
  const { displayText } = useStreamTextReveal(text, streaming)
  if (!displayText.length && showCaret) {
    return <StreamingTextPlaceholder className={className} sx={sx} />
  }
  if (!displayText.length) return null
  const { settled, tail } = streaming
    ? splitStreamTail(displayText)
    : { settled: displayText, tail: '' }
  const rootClass = [styles.root, streaming ? styles.rootStreaming : null, className]
    .filter(Boolean)
    .join(' ')
  return (
    <Box component={component} className={rootClass} sx={sx} aria-busy={streaming || undefined}>
      {renderStreamBody({ settled, tail, formatted })}
      {showCaret && streaming ? <StreamingCaret /> : null}
    </Box>
  )
}
